<template>
  <div >
    <h3 class="title title_mark" style="positon:relative;left:-20px;top:-20px">生长性能</h3>
    <a-table
      :scroll="{ x: 500 }"
      :columns="columns"
      :data-source="list"
      class="nopaddingEstimateTable"
      :pagination="false"
      row-key="id"
      style="margin:-20px 0 0 0"
    >
      <template v-for="el in fixedArr" :slot="el" slot-scope="text">
        <span :key="el">{{ text ? Number(text).toFixed(2) : "-" }}</span>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  expectationEstimationColumns,
  pregnantExpectationEstimationList,
} from "../../../../EstimateConfig/estimateConfig";
import { getRequest } from "@/components/Common/Utils/Utils";
import { mapState } from "vuex";
export default {
  props: ["isAdd", "resId", "tabKey", "details"],
  data() {
    return {
      list: [],
      fixedArr: [],
      sectionList: [],
      estimateId: getRequest("id"),
      isRefresh: true,
      pregnantExpectationEstimationList,
      energySystemName: ''
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapState("estimate", ["dataDictionary"]),
    columns() {
      let newColumns = this.dealColumns();
      return newColumns;
    },
  },
  watch: {
    resId(val) {
      this.isRefresh = true;
      this.getDetails(val);
    },
    tabKey() {
      if (this.resId && this.isRefresh) this.init(this.resId);
    },
    details: {
      handler() {
        this.getName()
        this.init(this.resId);
      },
      deep: true,
    },
  },
  methods: {
    dealColumns() {
      let newColumns = [...expectationEstimationColumns];
      this.sectionList.forEach((el, index) => {
        newColumns.push({
          title: el.name,
          dataIndex: `f${index + 1}`,
          children: [
            {
              title: "预估值",
              dataIndex: `${el.field}`,
              scopedSlots: { customRender: `${el.field}` },
              width: 120,
            },
          ],
        });
      });
      return newColumns;
    },
    init() {
      if (this.estimateId && this.isAdd) {
        this.getDetails(this.estimateId);
      } 
      // else if (!this.isAdd && this.resId) {
      //   this.getDetails(this.resId);
      // }
    },
    getDetails(id) {
      this.sectionList = [];
      this.list = [];
      if (!id) return;
      this.isRefresh = false;
      this.$http
        .get(
          `/sat-maximization/opweightrangeformula/subDetail?predictionId=${id}`
        )
        .then((res) => {
          let { success, data } = res || {};
          if (success) {
            //动态生成头部区间
            let sectionList = [];
            data.forEach((el) => {
              sectionList.push({
                name: `${el.initialDayinput}-${el.finalDayinput}天`,
                field: `${el.initialDayinput}-${el.finalDayinput}`,
              });
              this.fixedArr.push(`${el.initialDayinput}-${el.finalDayinput}`);
            });

            //生成表格数据
            let list = []
            this.pregnantExpectationEstimationList && this.pregnantExpectationEstimationList.forEach((item) => {
              let obj = {
                 name: item.name.indexOf("能量体系名称") >= 0 ? item.name.replace("【能量体系名称】",this.energySystemName.replace('体系'," ")) : item.name,
                // name: item.name,
                unit: item.unit,
              };
              data.forEach((el) => {
                let dataBase = el.opWeightRangeFormula;
                obj[`${el.initialDayinput}-${el.finalDayinput}`] = dataBase[item.field];   
              });
              list.push(obj);
            });
            this.list = [...list]
            this.sectionList = [...sectionList]
          }
        });
    },

     //能量体系名称
    getName() {
      let { prediction } = this.details;
      let { energySystem } = prediction;
      let obj = this.dataDictionary.EnergySystem.find(
        (el) => el.dictKey === energySystem
      );
      this.energySystemName = obj.dictValue.replace("体系", "") || " ";
    },
  },
};
</script>